export type PasswordRecoveryFormValues = {
    username: string;
};

export const buildPasswordRecoveryInput = (values: PasswordRecoveryFormValues) => ({
    email: values.username.trim()
});

const RETURN_URL_PARAM = "returnUrl";

export const buildLoginReturnPath = (returnPath: string) =>
    `/Login?${RETURN_URL_PARAM}=${encodeURIComponent(returnPath)}`;

// Only same-app organizer paths are accepted, so the login page cannot be used as an open redirect.
export const resolveLoginReturnPath = (search: string): string => {
    const value = new URLSearchParams(search).get(RETURN_URL_PARAM) ?? "";
    return value.startsWith("/Admin/") || value === "/Admin" ? value : "/";
};
